
import { MessageApi } from '@/api/messages';
import { CategorieMessage } from '@/model/enum-types/categorie-message';
import { CodeDomaine } from '@/model/enum-types/code-domaine';
import StoreBuilder from '../store-builder';

export function getMessagesStoreBuilder (name:string, domaine:CodeDomaine, categorie:CategorieMessage):StoreBuilder {
  const builder = new StoreBuilder(name);
  builder.addStatePart('liste', [], () => MessageApi.getMessages(categorie));

  builder.addStatePart('saisieEnCours', null, null, 'SESSION');

  builder.setGetters({
    domaine: () => domaine,
    categorie: () => categorie
  });

  return builder;
}
